import { reactive } from "vue";
import { LngLat, type GeolocatePositionEvent } from "maplibre-gl";
import distance from "@turf/distance";
import { TLineString } from './shared/types/geojson';


//TODO VUE3: works? make a pinia store instead?
export const locationStore = reactive({
	history: [] as GeolocationPosition[],
	currentTime: 0,
	trackLength: 60000,
	currentPosition: undefined as LngLat | undefined,
	currentAccuracy: 0,
	// locationProgress: -1,
	// distanceFromTrack: 0,
});




export function updateLocation(loc: GeolocatePositionEvent | undefined, trackFeature: TLineString, trackLength: number): void {
	if (loc && loc.type == "geolocate") {
		// const last = locationStore.history.length > 0 ? locationStore.history[locationStore.history.length-1] : undefined;
		// if(last && last.coords.longitude == loc.coords.longitude && last.coords.latitude == loc.coords.latitude)
		// 	return;

		//if the accuracy i higher than this, let's say we don't know where we are.
		if (loc.coords.accuracy > 150) {
			locationStore.currentPosition = undefined;
			return;
		}

		let dist = 0;
		if (locationStore.history.length > 0) {
			const last = locationStore.history[locationStore.history.length - 1];
			dist = distance([last.coords.longitude, last.coords.latitude], [loc.coords.longitude, loc.coords.latitude]);
		}

		locationStore.history.push({ coords: loc.coords, timestamp: loc.timestamp, distance: dist } as any);
		locationStore.currentPosition = new LngLat(loc.coords.longitude, loc.coords.latitude);
		locationStore.currentAccuracy = loc.coords.accuracy;
		updateCurrentTime();
	}
	// updateLocationProgress(trackFeature, trackLength);
}

// function updateLocationProgress(trackFeature: TLineString, trackLength: number) {
// 	if (locationStore.currentPosition && trackFeature) {
// 		const pt = nearestPointOnLine(trackFeature, locationStore.currentPosition.toArray());
// 		locationStore.distanceFromTrack = pt.properties.dist!;
// 		if (pt.properties.dist! < 0.1) {
// 			locationStore.locationProgress = pt.properties.location! / trackLength;
// 			return;
// 		}
// 	}
// 	locationStore.locationProgress = -1;
// }

function updateCurrentTime() {
	const currentTime = new Date().getTime();

	const wasEmpty = locationStore.history.length == 0;

	//trim away old positions that are no longer visible
	const h = locationStore.history.filter((item, i, arr) => {
		const next = i < arr.length - 1 ? arr[i + 1] : undefined;
		if (next)
			return currentTime - next.timestamp < locationStore.trackLength;
		return true;
	});

	//opt: will not trigger update if list didn't change.
	if (locationStore.history.length != h.length)
		locationStore.history = h;

	//opt: if we have nothing to draw, don't update since it will trigger a re-render
	if (!wasEmpty) {
		locationStore.currentTime = currentTime;
	}
}

function tick() {
	updateCurrentTime();
	setTimeout(tick, 2000);
}

tick();